module.exports = __webpack_public_path__ + "img/CRT_P2_Sword-001.5a325275.png";